/**
 * Processes media resource URL to ensure proper formatting
 * @param url The original URL from the resource
 * @returns Properly formatted URL
 */
export const getMediaUrl = (url: string | null | undefined): string => {
  if (!url) return ''
  
  // Check if URL is literally "null" string (not a valid URL)
  const trimmed = url.trim()
  if (trimmed === '' || trimmed === 'null' || trimmed === '/null') {
    return ''
  }

  // Encode spaces in URL (replace with %20)
  url = url.replace(/ /g, '%20')

  return url
}
